import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LangProvider } from "@/lib/i18n";
import { useSmoothScroll } from "@/lib/smooth";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Stats from "@/components/site/Stats";
import Marquee from "@/components/site/Marquee";
import Bento from "@/components/site/Bento";
import RoutesSection from "@/components/site/RoutesSection";
import Gallery from "@/components/site/Gallery";
import Quote from "@/components/site/Quote";
import Footer from "@/components/site/Footer";
import WhatsAppFab from "@/components/site/WhatsAppFab";
import AdminPage from "@/pages/Admin";

function Site() {
  useSmoothScroll();
  return (
    <div className="relative bg-[#090A0C] text-zinc-100">
      <Nav />
      <main>
        <Hero />
        <Stats />
        <Marquee />
        <Bento />
        <RoutesSection />
        <Gallery />
        <Quote />
      </main>
      <Footer />
      <WhatsAppFab />
      <Toaster theme="dark" position="top-center" />
    </div>
  );
}

export default function App() {
  return (
    <LangProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/admin" element={<AdminPage />} />
          <Route path="*" element={<Site />} />
        </Routes>
      </BrowserRouter>
    </LangProvider>
  );
}
